// extracted by mini-css-extract-plugin
export default {"ProjectsContainer":"Projects_ProjectsContainer__nrvgQ","title":"Projects_title__6s+oo"};